// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_math from "rescript/lib/es6/js_math.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";

function applyHeight(element) {
  var rect = element.getBoundingClientRect();
  var px = String(Js_math.ceil_int(rect.height)) + "px";
  document.documentElement.style.setProperty("--account-bar-height", px);
}

function mounted() {
  var self = this ;
  var element = self.el;
  if (!DomEl$GameDataCore.isHtmlElement(element)) {
    return ;
  }
  applyHeight(element);
  var observer = new ResizeObserver((function () {
          applyHeight(element);
        }));
  observer.observe(element);
  self._barRo = observer;
}

function updated() {
  var self = this ;
  var element = self.el;
  if (DomEl$GameDataCore.isHtmlElement(element)) {
    return applyHeight(element);
  }
  
}

function destroyed() {
  var self = this ;
  var observer = self._barRo;
  if (!(observer == null)) {
    observer.disconnect();
    return ;
  }
  
}

var AccountBarMeasure = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

export {
  applyHeight ,
  mounted ,
  updated ,
  destroyed ,
  AccountBarMeasure ,
}
/* mounted Not a pure module */
